import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import client from '../lib/apolloClient';
import configureStore from '../store/findBobPublicStore';
import getMessages from '../lib/i18n/getMessages';
import { CurrencyProvider } from '../hooks/useCurrency';
import SuccessionSettings from '../components/Succession/SuccessionSettings';

const SuccessionSettingsContainer = (props, railsContext) => {
  // Merge company features
  const mergedCompany = props.company
    ? { ...props.company, feature_types: (props.company.feature_types || props.features || []), features: (props.company.features || props.features || []) }
    : {
      host: railsContext && railsContext.company_host,
      features: (railsContext && railsContext.features) || [],
      file_import_disclaimer: railsContext && railsContext.file_import_disclaimer,
      name: railsContext && railsContext.company_name,
      branded_name: railsContext && railsContext.company_branded_name,
      short_name: railsContext && railsContext.company_short_name,
    };

  const initialState = {
    company: mergedCompany,
    user: props.current_user,
    intl: { locale: (railsContext && railsContext.i18nLocale) || 'en' },
  };

  const store = configureStore(initialState);
  const locale = (railsContext && railsContext.i18nLocale) || 'en';
  window.locale = locale;
  window.currency = (railsContext && railsContext.currency) || window.currency || 'USD';

  if (typeof document !== 'undefined') {
    document.store = store;
  }

  return (
    <CurrencyProvider currency={(railsContext && railsContext.currency) || window.currency || 'USD'}>
      <Provider store={store}>
        <IntlProvider messages={getMessages(locale)} locale={locale}>
          <ApolloProvider client={client}>
            <SuccessionSettings {...props} />
          </ApolloProvider>
        </IntlProvider>
      </Provider>
    </CurrencyProvider>
  );
};

export default SuccessionSettingsContainer;

